// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************


// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =====================================================================================================================
// Splide
// =====================================================================================================================

import Splide from '@splidejs/splide';



// =================================================================================================================
// Testimonial Slider
// =================================================================================================================
const testimonialSlider = document.querySelectorAll('.testimonial-slider .splide');
if (testimonialSlider.length) {
    testimonialSlider.forEach(function(testimonialSlider) {
        const slider = new Splide(testimonialSlider, {
            type: 'loop',
            arrows: false,
            pagination: true,
            autoplay: true,
            perPage: 1,
        }).mount();
    });
}



// =================================================================================================================
// Logo Slider
// =================================================================================================================
const logoSlider = document.querySelectorAll('.logo-slider .splide');
if (logoSlider.length) {
    logoSlider.forEach(function(logoSlider) {
        const slider = new Splide(logoSlider, {
            type: 'loop',
            arrows: false,
            pagination: false,
            autoplay: false,
            perPage: 7,
            breakpoints: {
                768: {
                    perPage: 1,
                },
                992: {
                    perPage: 4,
                },
            }
        }).mount();
    });
}



// =================================================================================================================
// Photo Slider
// =================================================================================================================
const photoSlider = document.querySelectorAll('.photo-slider .splide');
if (photoSlider.length) {
    photoSlider.forEach(function(photoSlider) {
        const slider = new Splide(photoSlider, {
            type: 'loop',
            arrows: true,
            pagination: false,
            autoplay: false,
            perPage: 1
        }).mount();
    });
}